"use strict";

require("core-js/modules/es6.array.filter.js");
var _Object$keys = require("@babel/runtime-corejs2/core-js/object/keys");
var _Object$getOwnPropertySymbols = require("@babel/runtime-corejs2/core-js/object/get-own-property-symbols");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptor");
var _Object$getOwnPropertyDescriptors = require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptors");
var _Object$defineProperties = require("@babel/runtime-corejs2/core-js/object/define-properties");
var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.gDesktopFirstMediaQueries = exports.default = void 0;
var _entries = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/entries"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/slicedToArray"));
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/taggedTemplateLiteral"));
var _themeMapper = require("@gravity/theme-mapper");
var _styledComponents = require("styled-components");
var _templateObject;
function cov_1hbigbvc5k() {
  var path = "/codebuild/output/src1825986617/src/bitbucket.org/secutix/gravity/apps/tnwi/temp/helpers/Utils/lib/gMediaQueries.js";
  var hash = "e7b1bcabb38097344fbf717529d84934fa6f7427";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/codebuild/output/src1825986617/src/bitbucket.org/secutix/gravity/apps/tnwi/temp/helpers/Utils/lib/gMediaQueries.js",
    statementMap: {
      "0": {
        start: {
          line: 20,
          column: 19
        },
        end: {
          line: 24,
          column: 1
        }
      },
      "1": {
        start: {
          line: 20,
          column: 58
        },
        end: {
          line: 24,
          column: 1
        }
      },
      "2": {
        start: {
          line: 20,
          column: 90
        },
        end: {
          line: 24,
          column: 1
        }
      },
      "3": {
        start: {
          line: 27,
          column: 22
        },
        end: {
          line: 33,
          column: 1
        }
      },
      "4": {
        start: {
          line: 28,
          column: 32
        },
        end: {
          line: 31,
          column: 3
        }
      },
      "5": {
        start: {
          line: 36,
          column: 34
        },
        end: {
          line: 42,
          column: 1
        }
      },
      "6": {
        start: {
          line: 37,
          column: 32
        },
        end: {
          line: 40,
          column: 3
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 20,
            column: 19
          },
          end: {
            line: 20,
            column: 20
          }
        },
        loc: {
          start: {
            line: 20,
            column: 58
          },
          end: {
            line: 24,
            column: 1
          }
        },
        line: 20
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 20,
            column: 58
          },
          end: {
            line: 20,
            column: 59
          }
        },
        loc: {
          start: {
            line: 20,
            column: 90
          },
          end: {
            line: 24,
            column: 1
          }
        },
        line: 20
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 28,
            column: 2
          },
          end: {
            line: 28,
            column: 3
          }
        },
        loc: {
          start: {
            line: 28,
            column: 32
          },
          end: {
            line: 31,
            column: 3
          }
        },
        line: 28
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 37,
            column: 2
          },
          end: {
            line: 37,
            column: 3
          }
        },
        loc: {
          start: {
            line: 37,
            column: 32
          },
          end: {
            line: 40,
            column: 3
          }
        },
        line: 37
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 20,
            column: 32
          },
          end: {
            line: 20,
            column: 53
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 20,
            column: 42
          },
          end: {
            line: 20,
            column: 53
          }
        }],
        line: 20
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0
    },
    b: {
      "0": [0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "e7b1bcabb38097344fbf717529d84934fa6f7427"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_1hbigbvc5k = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_1hbigbvc5k();
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
/**
 * Represents a media query object.
 * @typedef MediaQueryObject
 * @type {object}
 * @property {function} sm - Media query function for small screens.
 * @property {function} md - Media query function for medium screens.
 * @property {function} lg - Media query function for large screens.
 * @property {function} xl - Media query function for extra large screens.
 */
/**
 * Generates a CSS media query string with specified breakpoint and query type.
 * @param {number} breakpoint - The breakpoint value in pixels.
 * @param {'min-width' | 'max-width'} [queryBy='min-width'] - The type of media query ('min-width' or 'max-width').
 * @returns {function} A function that accepts CSS template literals and interpolations to generate media query styles.
 */
cov_1hbigbvc5k().s[0]++;
var mediaQuery = function mediaQuery(breakpoint) {
  var queryBy = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (cov_1hbigbvc5k().b[0][0]++, 'min-width');
  cov_1hbigbvc5k().f[0]++;
  cov_1hbigbvc5k().s[1]++;
  return function (strings) {
    cov_1hbigbvc5k().f[1]++;
    cov_1hbigbvc5k().s[2]++;
    for (var _len = arguments.length, interpolations = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      interpolations[_key - 1] = arguments[_key];
    }
    return (0, _styledComponents.css)(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2.default)(["\n  @media only screen and (", ") {\n    ", ";\n  }\n"])), "".concat(queryBy, ": ").concat(breakpoint, "px"), _styledComponents.css.apply(void 0, [strings].concat(interpolations)));
  };
};

/** @type {MediaQueryObject} */
var gMediaQueries = (cov_1hbigbvc5k().s[3]++, (0, _entries.default)(_themeMapper.evolutionTheme.breakpoints).reduce(function (acc, _ref) {
  var _ref2 = (0, _slicedToArray2.default)(_ref, 2),
    name = _ref2[0],
    breakpoint = _ref2[1];
  cov_1hbigbvc5k().f[2]++;
  cov_1hbigbvc5k().s[4]++;
  return _objectSpread(_objectSpread({}, acc), {}, (0, _defineProperty2.default)({}, name, mediaQuery(breakpoint, 'min-width')));
}, {}));

/** @type {MediaQueryObject} */
var gDesktopFirstMediaQueries = exports.gDesktopFirstMediaQueries = (cov_1hbigbvc5k().s[5]++, (0, _entries.default)(_themeMapper.evolutionTheme.breakpoints).reduce(function (acc, _ref3) {
  var _ref4 = (0, _slicedToArray2.default)(_ref3, 2),
    name = _ref4[0],
    breakpoint = _ref4[1];
  cov_1hbigbvc5k().f[3]++;
  cov_1hbigbvc5k().s[6]++;
  return _objectSpread(_objectSpread({}, acc), {}, (0, _defineProperty2.default)({}, name, mediaQuery(breakpoint - 1, 'max-width')));
}, {}));
var _default = exports.default = gMediaQueries;